/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {css, StyleSheet} from 'aphrodite';
import reactUpdate from 'immutability-helper';
import React from 'react';
import _ from 'underscore';

import ManageSelectorsModalClass from 'notebook/plain-tables/selectors/ManageSelectorsModal';
import SelectorDAO from 'notebook/plain-tables/selectors/SelectorDAO';
import {ButtonStyle} from 'ui-library/buttons/Button';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import ModalAnchor from 'ui-library/ModalAnchor';
import * as ModalContainer from 'ui-library/ModalContainer';
import Modal from 'ui-library/modals/Modal';

interface Props {
  open: boolean;
  setSelector: (...args: Array<any>) => any;
  selectorsLink: {
    value: Array<any>;
    requestChange?: ((...args: Array<any>) => any) | null;
    selectorUsageCounts: any;
  };
  onRequestClose: () => void;
}

type State = any;

const getDefaultSelectedState = (props: Props): State => {
  const defaultSelectorId =
    props.selectorsLink.value[0] != null ? props.selectorsLink.value[0].staticId : null;
  return {
    selectedId: defaultSelectorId,
  };
};

const findSelectedSelector = (props: Props, state: State): any =>
  _.findWhere(props.selectorsLink.value, {staticId: state.selectedId})!;

class SetSelectorModal extends React.Component<Props, State> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  toggleManageSelectorsModal = (prevState: any, curState: any, manageSelectorsModalProps: any) => {
    if (curState.showManageSelectorsModal) {
      ModalContainer.open(
        ManageSelectorsModalClass,
        <ManageSelectorsModalClass {...manageSelectorsModalProps} />
      );
    } else if (prevState.showManageSelectorsModal && !curState.showManageSelectorsModal) {
      this.closeManageSelectorsModal();
    }
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  openManageSelectorsModal = (initialSelectorId?: any) => {
    this.setState({showManageSelectorsModal: true, initialSelectorId});
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  closeManageSelectorsModal = () => {
    this.setState({showManageSelectorsModal: false, initialSelectorId: null});
    ModalContainer.close(ManageSelectorsModalClass);
  };

  static getDerivedStateFromProps(nextProps: Props, prevState: State): Partial<State> | null {
    const matchingSelector = findSelectedSelector(nextProps, prevState);
    if (
      (prevState.selectedId != null && matchingSelector == null) ||
      (prevState.selectedId == null && nextProps.selectorsLink.value.length > 0)
    ) {
      return getDefaultSelectedState(nextProps);
    }
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  openManageModal = ({createBeforeOpening}: any) => {
    if (createBeforeOpening) {
      const newSelector = SelectorDAO.makeSelector('Untitled Selector');
      const newSelectors = reactUpdate(this.props.selectorsLink.value, {$push: [newSelector]});
      this.props.selectorsLink.requestChange!(newSelectors);
    }
    this.openManageSelectorsModal();
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setSelectedId = (selectorId: any) => {
    this.setState({selectedId: selectorId});
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  getSelectedName = () => {
    const matchingSelector = findSelectedSelector(this.props, this.state);
    if (matchingSelector != null) {
      return matchingSelector.name;
    }
    return '';
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setSelectorAndClose = () => {
    this.props.setSelector(this.state.selectedId);
    this.props.onRequestClose();
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  clearSelectorAndClose = () => {
    this.props.setSelector(null);
    this.props.onRequestClose();
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  renderTitle = () => <div>Set selector</div>;

  state: State = {
    ...getDefaultSelectedState(this.props),
    showManage: false,
    showManageSelectorsModal: false,
    initialSelectorId: null,
  };

  componentDidUpdate(prevProps: Props, prevState: State): void {
    const manageSelectorsModalProps = {
      doneText: 'Back',
      initialSelectorId: this.state.selectedId,
      locked: false, // Not locked if able to set selectors.
      selectorsLink: this.props.selectorsLink,
      onRequestClose: this.closeManageSelectorsModal,
    };
    this.toggleManageSelectorsModal(prevState, this.state, manageSelectorsModalProps);
  }

  render(): JSX.Element {
    let option;
    const selectors = this.props.selectorsLink.value;
    const isLocked = this.props.selectorsLink.requestChange == null;
    return (
      <ModalAnchor open={this.props.open}>
        <Modal
          title={this.renderTitle()}
          onRequestClose={this.props.onRequestClose}
          onRequestSubmit={!isLocked ? this.setSelectorAndClose : undefined}
          buttons={
            isLocked
              ? [{text: 'Close', cancel: true}]
              : [
                  {text: 'Set', submit: true, disabled: this.state.selectedId == null},
                  {
                    text: 'Clear',
                    onClick: this.clearSelectorAndClose,
                    style: ButtonStyle.NEGATIVE,
                    pullLeft: true,
                  },
                ]
          }
        >
          {selectors.length > 0 ? (
            <div>
              <div className={css(styles.legacySelect)}>
                <SelectDropdown
                  disabled={isLocked}
                  menu={
                    <Menu
                      scrollable={true}
                      height={Menu.HEIGHTS.SMALL}
                      width={Menu.WIDTHS.FULL}
                      value={this.state.selectedId}
                    >
                      {Array.from(selectors).map((selector) => (
                        <Option
                          key={selector.staticId}
                          value={selector.staticId}
                          onSelect={this.setSelectedId}
                        >
                          {selector.name}
                        </Option>
                      ))}
                    </Menu>
                  }
                  displayName={this.getSelectedName()}
                />
              </div>
              {this.state.selectedId != null ? (
                <ul>
                  {(() => {
                    const result = [];
                    const iterable = _.findWhere(selectors, {staticId: this.state.selectedId}).options;
                    for (let i = 0; i < iterable.length; i++) {
                      option = iterable[i];
                      result.push(<li key={i}>{option}</li>);
                    }
                    return result;
                  })()}
                </ul>
              ) : undefined}
              {!isLocked ? (
                <p>
                  <a onClick={this.openManageModal}>Manage your selectors</a>
                </p>
              ) : undefined}
            </div>
          ) : !isLocked ? (
            <div>
              <p>This document doesn't have any selectors yet.</p>
              <a onClick={this.openManageModal.bind(null, {createBeforeOpening: true})}>
                Create a new selector first.
              </a>
            </div>
          ) : (
            <div>This document doesn't have any selectors.</div>
          )}
        </Modal>
      </ModalAnchor>
    );
  }
}

const styles = StyleSheet.create({
  legacySelect: {
    margin: '0 0 10px',
  },
});

export default SetSelectorModal;
